import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f544820"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pc-loby"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "logo" })
], -1))
const _hoisted_3 = { class: "menu" }
const _hoisted_4 = { class: "game-option-wrap" }
const _hoisted_5 = { class: "game-option-group" }
const _hoisted_6 = {
  key: 0,
  class: "active"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "game-option-divider" }, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "active"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "game-option-divider" }, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "active"
}
const _hoisted_11 = { class: "list-container" }
const _hoisted_12 = {
  key: 1,
  class: "m-loby"
}
const _hoisted_13 = { class: "m-header" }
const _hoisted_14 = { class: "m-inf" }
const _hoisted_15 = { class: "m-label" }
const _hoisted_16 = { class: "m-value" }
const _hoisted_17 = { class: "m-inf" }
const _hoisted_18 = { class: "m-label" }
const _hoisted_19 = { class: "m-value" }
const _hoisted_20 = { class: "m-tab-container" }
const _hoisted_21 = { class: "m-list-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pc_list_item = _resolveComponent("pc-list-item")!
  const _component_icon_menu = _resolveComponent("icon-menu")!
  const _component_mobile_list_item = _resolveComponent("mobile-list-item")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["loby-root", { 'is-not-ipad': !_ctx.isIpadProDevice }])
  }, [
    (_ctx.deviceOrientation === 'landscape' || _ctx.isIpadProDevice)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "menu-item",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDialog('bet-history')))
            }, _toDisplayString(_ctx.t('menu.accounthistory')), 1),
            _createElementVNode("div", {
              class: "menu-item",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.visitCustumerService && _ctx.visitCustumerService(...args)))
            }, _toDisplayString(_ctx.t('menu.cutomerservice')), 1),
            _createElementVNode("div", {
              class: "menu-item",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToRule && _ctx.goToRule(...args)))
            }, _toDisplayString(_ctx.t('menu.gamerules')), 1),
            _createElementVNode("div", {
              class: "menu-item",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDialog('edit-password')))
            }, _toDisplayString(_ctx.t('menu.changepwd')), 1),
            _createElementVNode("div", {
              class: "menu-item",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDialog('lang')))
            }, _toDisplayString(_ctx.t('menu.language')), 1),
            _createElementVNode("div", {
              class: "menu-item",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleFullScreen && _ctx.toggleFullScreen(...args)))
            }, _toDisplayString(_ctx.isFull ? _ctx.t('menu.exitfullscreen') : _ctx.t('menu.fullscreen')), 1),
            _createElementVNode("div", {
              class: "menu-item",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.logOut && _ctx.logOut(...args)))
            }, _toDisplayString(_ctx.t('menu.quit')), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "game-option",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeTab(_ctx.GameType.BACCARAT)))
              }, [
                (_ctx.activeTab === _ctx.GameType.BACCARAT)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('baccarat.name')), 1)
              ]),
              _hoisted_7,
              _createElementVNode("div", {
                class: "game-option",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeTab(_ctx.GameType.DRAGON_TIGER)))
              }, [
                (_ctx.activeTab === _ctx.GameType.DRAGON_TIGER)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('dragontiger.name')), 1)
              ]),
              _hoisted_9,
              _createElementVNode("div", {
                class: "game-option",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changeTab(_ctx.GameType.DEAL_FIRST)))
              }, [
                (_ctx.activeTab === _ctx.GameType.DEAL_FIRST)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('menu.dealfirst')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.desks, (i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: `pc-item-${i}`
              }, [
                _createVNode(_component_pc_list_item, {
                  activetable: _ctx.activeDesk,
                  "active-tab": _ctx.activeTab,
                  onEnterTable: _ctx.enterTable,
                  mdata: i,
                  onEndSession: _ctx.handleExpiredSession
                }, null, 8, ["activetable", "active-tab", "onEnterTable", "mdata", "onEndSession"])
              ]))
            }), 128))
          ])
        ]))
      : (_ctx.deviceOrientation === 'portrait')
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.t('common.account')) + ":", 1),
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.user), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.t('common.balance')) + ":", 1),
                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.coin), 1)
              ]),
              _createElementVNode("div", {
                class: "m-btn-setting",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showDialog('setting')))
              }, [
                _createVNode(_component_icon_menu)
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", {
                class: _normalizeClass({ 'active': _ctx.activeTab === _ctx.GameType.BACCARAT }),
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changeTab(_ctx.GameType.BACCARAT)))
              }, _toDisplayString(_ctx.t('baccarat.name')), 3),
              _createElementVNode("div", {
                class: _normalizeClass({ 'active': _ctx.activeTab === _ctx.GameType.DRAGON_TIGER }),
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.changeTab(_ctx.GameType.DRAGON_TIGER)))
              }, _toDisplayString(_ctx.t('dragontiger.name')), 3),
              _createElementVNode("div", {
                class: _normalizeClass({ 'active': _ctx.activeTab === _ctx.GameType.DEAL_FIRST }),
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.changeTab(_ctx.GameType.DEAL_FIRST)))
              }, _toDisplayString(_ctx.t('menu.dealfirst')), 3)
            ]),
            _createElementVNode("div", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.desks, (i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "m-item",
                  key: `mobile-item-${i}`
                }, [
                  _createVNode(_component_mobile_list_item, {
                    "active-tab": _ctx.activeTab,
                    activetable: _ctx.activeDesk,
                    onEnterTable: _ctx.enterTable,
                    onEndSession: _ctx.handleExpiredSession,
                    mdata: i
                  }, null, 8, ["active-tab", "activetable", "onEnterTable", "onEndSession", "mdata"])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
  ], 2))
}